import { render, staticRenderFns } from "./affiliateUserDetail.vue?vue&type=template&id=9f4ffe8e&scoped=true"
import script from "./affiliateUserDetail.vue?vue&type=script&lang=js"
export * from "./affiliateUserDetail.vue?vue&type=script&lang=js"
import style0 from "./affiliateUserDetail.vue?vue&type=style&index=0&id=9f4ffe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f4ffe8e",
  null
  
)

export default component.exports